<template>
  <div class="text-[.385rem]">
    <Header :title="title" :showBack="true"></Header>
    <!-- 头部输入/选择框 -->
    <form action="" class="form_content">
      <div class="form_item">
        <span>日期：</span>
        <div class="form_input" @click.stop="$refs.calendar.show = true">
          {{ form.beginDate }} ~ {{ form.endDate }}
        </div>
      </div>
      <div class="form_item_special">
        <div class="form_item" style="width: 45%">
          <label>线路：</label>
          <div class="form_input text-row1" @click.stop="onLineSelectShow">
            {{ form.lineNameList.toString() }}
          </div>
        </div>
        <div class="form_item">
          <label>订单：</label>
          <input
            type="text"
            v-model="form.orderNo"
            class="form_input"
            placeholder="  输入订单号"
          />
        </div>
      </div>
      <div class="form_item_special">
        <div class="form_item">
          <label>姓名：</label>
          <input
            type="text"
            class="form_input"
            v-model="form.custName"
            placeholder="  输入乘车人姓名"
          />
        </div>
        <div class="form_item">
          <label>电话：</label>
          <input
            type="text"
            class="form_input"
            v-model="form.custTel"
            placeholder="  输入乘车人电话"
          />
        </div>
      </div>
      <div class="form_item_column">
        <div class="form_item">
          <div class="title">订单来源：</div>
          <div
            class="form_input text-row1"
            @click.stop="clickOrderSourcePopupShow"
          >
            {{ form.CompanyOrderSourceName }}
          </div>
        </div>
        <div class="form_item">
          <div class="title">票状态：</div>
          <van-checkbox-group
            direction="horizontal"
            v-model="form.TicketStatusIDList"
          >
            <van-checkbox
              :name="item.status"
              shape="square"
              v-for="(item, index) in ticketStatusList"
              :key="index"
              icon-size="16"
              >{{ item.label }}</van-checkbox
            >
          </van-checkbox-group>
        </div>
        <div class="button">
          <span @click="clickTicketStatusButton(0)">全选</span>
          <span @click="clickTicketStatusButton(1)">取消</span>
        </div>
      </div>

      <button class="search_btn" type="button" @click="doQuery">查询</button>
    </form>
    <!-- 订单详情 -->
    <van-list
      class="m-1"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :immediate-check="false"
      @load="onLoad"
      ref="list"
    >
      <div class="order_panel mt-1 ">
        <span style="font-weight:700;font-size:.4rem; margin-right:.3rem"
          >合计</span
        >
        <span>
          有效票：
          <span style="color:red">{{ validTicketTotal }}</span>
          张，有效票金额：
          <span style="color:red">{{ validTicketPrice }}</span>
          元
        </span>
      </div>

      <!-- 订单面板 -->
      <div class="order_panel mt-1" v-for="(item, index) in list" :key="index">
        <div class="panel_index">{{ index + 1 }}</div>
        <div class="panel_item">
          <div class="panel_item_content">
            <p class="item_content_label">班次:</p>
            <div class="item_content_info info_title flex-1">
              {{ item.ClassDate + " " + item.ClassTime }}
              <p
                class="info_btn"
                :style="{
                  backgroundColor: `${statusName[item.TicketStatusID].bgc}`,
                }"
              >
                {{ statusName[item.TicketStatusID].text }}
              </p>
            </div>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">线路:</p>
            <div class="item_content_info info_title flex-1">
              {{ item.LineName }}
            </div>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">订单号:</p>
            <p class="item_content_info flex-1">{{ item.OrderNo }}</p>
          </div>
           <div class="panel_item_content" v-if="item.StartNodeName">
            <p class="item_content_label">上车点:</p>
            <p class="item_content_info flex-1">{{ item.StartNodeName }}</p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">
              {{ item.InvalidDateTime ? "退票人:" : "检票点:" }}
            </p>
            <p class="item_content_info flex-1">{{ item.CheckNodeName }}</p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">
              {{ item.InvalidDateTime ? "退票时间:" : "检票时间:" }}
            </p>
            <p class="item_content_info flex-1">{{ item.CheckDateTime }}</p>
          </div>
          <div class="panel_item_content">
            <p class="item_content_label">乘车人:</p>
            <p class="item_content_info flex-1">{{ item.CustName }}</p>
            <p class="item_content_label phone_label_width">电话:</p>
            <p class="item_content_info flex-1">{{ item.CustTel }}</p>
          </div>
        </div>
      </div>
    </van-list>
    <!-- 日历组件 -->
    <Calendar
      ref="calendar"
      type="range"
      :allow-same-day="true"
      @confirm="onConfirm"
    ></Calendar>
    <!-- 线路弹窗 -->
    <van-popup
      v-model="lineShow"
      round
      position="bottom"
      :style="{ height: '90%' }"
    >
      <van-checkbox-group v-model="form.lineGIDList">
        <van-checkbox
          :name="item.LineGID"
          shape="square"
          v-for="(item, index) in lineList"
          :key="index"
          >{{ item.LineName }}</van-checkbox
        >
      </van-checkbox-group>
      <van-button
        class="w100"
        type="default"
        block
        color="#33ccff"
        size="small"
        @click="onSelectLine"
        >确认</van-button
      >
    </van-popup>

    <!-- 订单来源弹窗 -->
    <van-popup
      v-model="orderSourcePopupShow"
      round
      position="bottom"
      :style="{ 'max-height': '90%' }"
    >
      <div class="order-source-popup">
        <van-field
          v-model="orderSourceSearchValue"
          placeholder="请输入"
          class="order-source-popup-input"
          @input="inputOrderSourceSearch"
        />
        <p class="order-source-popup-clear" @click="clickOrderSourcePopupClear">
          清空
        </p>
        <van-radio-group
          class="order-source-popup-radio"
          v-model="form.CompanyOrderSourceGID"
        >
          <van-radio
            class="popup-radio-item"
            v-for="(item, index) in orderSourceList"
            :key="index"
            :name="item.SourceCode"
          >
            {{ item.SourceName }}
          </van-radio>
        </van-radio-group>
        <van-button
          type="default"
          block
          color="#33ccff"
          size="small"
          @click="clickOrderSourcePopupConfirm"
          >确认</van-button
        >
      </div>
    </van-popup>
  </div>
</template>

<script>
import Header from "@/components/Header/Header";
import Calendar from "../../components/calendar.vue";
import calendar from "@/js/date";
export default {
  components: {
    Header,
    Calendar,
  },
  data() {
    return {
      title: "订单查询",
      operObj: JSON.parse(window.localStorage.getItem("adminInfo")),
      loading: false,
      finished: false,
      form: {
        beginDate: this.$moment().format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
        lineNameList: [],
        lineGIDList: [],
        orderNo: "",
        custName: "",
        custTel: "",
        CompanyOrderSourceGID: "", // 订单来源
        CompanyOrderSourceName: "", // 订单来源
        TicketStatusIDList: ["2"], // 车票状态
      },
      start: 0,
      limit: 5,
      list: [],
      lineShow: false,
      lineList: [],
      statusName: {
        1: { text: "锁定", bgc: "#444444" },
        2: { text: "已售", bgc: "#66dd00" },
        3: { text: "已退", bgc: "#ff0000" },
        4: { text: "已订", bgc: "#b94fff" },
        5: { text: "退订", bgc: "#ff0000" },
        6: { text: "取消", bgc: "#ff0000" },
        7: { text: "已废", bgc: "#42b59d" },
        8: { text: "已检", bgc: "#00cc00" },
        9: { text: "混检", bgc: "#0080ff" },
        10: { text: "手工检", bgc: "#00cc00" },
        11: { text: "已改签", bgc: "#fc7d37" },
        12: { text: "出票中", bgc: "#4ded80" },
      },
      statusNameBgc: {},

      orderSourcePopupShow: false, // 订单来源弹窗
      orderSourceList: [], // 订单来源弹窗
      orderSourceListSource: [], // 订单来源弹窗
      orderSourceSearchValue: "", // 订单来源搜索
      ticketStatusList: [
        { status: "1", label: "锁定" },
        { status: "2", label: "已售" },
        { status: "3", label: "已退" },
        { status: "4", label: "已订" },
        { status: "5", label: "退订" },
        { status: "6", label: "取消" },
        // { status: "7", label: "已废" },
        { status: "8", label: "已检" },
        { status: "9", label: "混检" },
        // { status: "10", label: "手工检" },
        { status: "11", label: "已改签" },
      ],
      validTicketTotal: 0, // 有效票
      validTicketPrice: 0, // 有效票金额
    };
  },
  created() {
    this.clickOrderSourcePopupShow();
  },
  methods: {
    // 点击票状态全选
    clickTicketStatusButton(item) {
      if (item === 0) {
        this.form.TicketStatusIDList = this.ticketStatusList.map(
          (item) => item.status
        );
      } else if (item === 1) {
        this.form.TicketStatusIDList = [];
      }
    },
    // 订单来源搜索
    inputOrderSourceSearch() {
      let value = this.orderSourceSearchValue;
      this.orderSourceList = this.orderSourceListSource.filter((item) => {
        if (item.SourceName.includes(value)) {
          return item;
        }
      });
    },
    /**
     * 点击订单来源
     * @param {Event} e 事件
     */
    async clickOrderSourcePopupShow(e) {
      if (this.orderSourceListSource.length < 1) {
        const res = await this.$http.post(this.$api.CompanyOrderSourceQuery);
        this.orderSourceList = res.data;
        this.orderSourceListSource = res.data;
      }

      const isRight = this.$utils.getRight("SearchOrderSource");
      const userGID = JSON.parse(window.localStorage.getItem("adminInfo")).GID; // 用户GID
      const userSource = this.orderSourceList.find(
        (item) => item.SysUserGID === userGID
      );
      // 通过事件触发 并且 有权限或没有订单来源没有匹配的用户才允许打开
      this.orderSourcePopupShow = e && (isRight || !userSource);
      if (userSource) {
        this.form.CompanyOrderSourceGID = userSource.SourceCode;
        this.form.CompanyOrderSourceName = userSource.SourceName;
      }
    },
    // 点击订单来源弹窗确认
    clickOrderSourcePopupConfirm() {
      this.orderSourceListSource.filter((item) => {
        if (item.SourceCode === this.form.CompanyOrderSourceGID) {
          this.form.CompanyOrderSourceName = item.SourceName;
        }
      });
      this.orderSourcePopupShow = false;
    },
    // 点击订单来源弹窗清空
    clickOrderSourcePopupClear() {
      this.form.CompanyOrderSourceGID = "";
      this.form.CompanyOrderSourceName = "";
    },
    //
    onBeginDateShow() {},
    // 线路选择函数
    async onLineSelectShow() {
      if (this.lineList.length <= 0) {
        await this.$http
          .post(this.$api.getGetCompLine, {
            OrganizationGID: this.operObj.OrganizationGID,
          })
          .then((res) => {
            this.lineList = res.data;
          });
      }
      this.lineShow = true;
    },
    // 查询按钮函数
    doQuery() {
      console.log(this.form);

      this.list = [];
      this.start = 0;
      this.finished = false;
      this.$nextTick(() => this.$refs.list.check());
      // this.onLoad();
    },
    // 确认线路函数
    onSelectLine() {
      this.form.lineNameList = this.lineList
        .filter((v) => this.form.lineGIDList.some((g) => g == v.LineGID))
        .map((v) => v.LineName);
      this.lineShow = false;
    },
    // 日历确认函数
    onConfirm(e) {
      this.form.beginDate = this.$moment(e[0]).format("YYYY-MM-DD");
      this.form.endDate = this.$moment(e[1]).format("YYYY-MM-DD");
    },

    onLoad() {
      const params = {
        ClassBeginDate: this.$moment(this.form.beginDate).format(
          "YYYY-MM-DD 00:00:00"
        ),
        ClassEndDate: this.$moment(this.form.endDate).format(
          "YYYY-MM-DD 23:59:59"
        ),
        CustName: this.form.custName,
        CustTel: this.form.custTel,
        OrderNo: this.form.orderNo,
        LineGID: this.form.lineGIDList.toString(),
        start: this.start,
        limit: this.limit,
        CompanyOrderSource: this.form.CompanyOrderSourceGID,
        TicketStatusIDList: this.form.TicketStatusIDList,
      };
      this.$http
        .post(this.$api.HandheldStatTicketOrderDetailQuery, params)
        .then((res) => {
          if (res.success) {
            this.validTicketTotal = res.summaryData.ValidTicketCount;
            this.validTicketPrice = res.summaryData.ValidTicketPrice;
            const total = res.total;
            res.data.forEach((item) => {
              item.ClassDate = item.ClassDate.split(" ")[0];
              item.ClassTime =
                item.ClassTime.split(":")[0] +
                ":" +
                item.ClassTime.split(":")[1];
              item.CheckDateTime =
                item.CheckDateTime &&
                this.$moment(item.CheckDateTime).format("YYYY-MM-DD HH:mm");
              this.list.push(item);
            });
            this.start += this.limit;
            this.loading = false;
            if (this.list.length >= total) {
              this.finished = true;
            }
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.form_content {
  padding-bottom: 15px;
  background-color: #fff;
  // 日期
  .form_item {
    display: flex;
    flex: 1;
    padding: 0.256rem;
    line-height: 0.75rem;
    box-sizing: border-box;
    & > input {
      width: 100%;
      border: none;
    }
    .date_split {
      margin: 0 0.256rem;
    }
    .form_input {
      border-bottom: 1px solid #000;
      min-width: 2.692rem;
      flex: 1;
      font-size: 0.359rem;
    }
    .van-button {
      flex: 1;
      margin-left: 0.128rem;
    }
  }
  .form_item_special {
    display: flex;
  }
  .search_btn {
    width: 40%;
    padding: 0.15rem;
    background-color: #33ccff;
    margin-top: 0.1rem;
    margin-left: 0.128rem;
    color: white;
    border-radius: 3px;
  }
  .form_item_column {
    .form_item {
      display: flex;
      .title {
        min-width: 2rem;
        text-align: left;
      }
      .van-checkbox {
        margin-bottom: 0.2rem;
      }
    }
    .button {
      padding: 0 0.3rem;
      text-align: right;
      & > :nth-child(1) {
        margin-right: 0.3rem;
        color: #33ccff;
      }
    }
  }
}
.order_panel {
  border-radius: 10px;
  padding: 0.15rem;
  background-color: #fff;
  text-align: left;
  position: relative;
  .panel_index {
    width: 0.5333rem;
    height: 0.5333rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.32rem;
    text-align: center;
    color: #fff;
    background-color: #f7a33c;
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
  }
  .panel_item {
    .panel_item_content {
      display: flex;
      line-height: 0.5rem;
      min-height: 1rem;
      .item_content_label {
        width: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #d8d8d8;
        background-color: #f9f9f9;
      }
      .item_content_info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #d8d8d8;
        padding: 0 5px;
        .info_btn {
          padding: 3px 3px;
          border-radius: 5px;
          color: #fff;
        }
        & > span {
          color: #000;
        }
      }
      .info_title {
        color: #fe6500;
      }
      .phone_label_width {
        width: 15%;
      }
    }
  }
}
.van-popup {
  .van-checkbox {
    margin: 0.267rem;
  }

  .van-button {
    font-size: 0.533rem;
  }
}
.order-source-popup {
  padding: 0.3rem;
  .order-source-popup-input {
    margin-bottom: 0.3rem;
  }
  .order-source-popup-clear {
    color: #33ccff;
    text-align: left;
    margin-bottom: 0.3rem;
  }
  .order-source-popup-radio {
    width: 100%;
    margin-bottom: 0.3rem;
    .popup-radio-item {
      margin-bottom: 0.2rem;
    }
  }
}
</style>
